import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'national',
    label: 'National Infographic',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
